'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'face-glasses';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e377';
var svgPathData = 'M256 480C132.3 480 32 379.7 32 256c0-22.2 3.2-43.7 9.3-64l6.7 0 0 96 0 16 16 0 160 0 16 0 0-16 0-96 32 0 0 96 0 16 16 0 160 0 16 0 0-16 0-96 6.7 0c6 20.3 9.3 41.8 9.3 64c0 123.7-100.3 224-224 224zM240 160l0-16-16 0L64 144l-2 0C100.7 77 173.1 32 256 32s155.3 45 194 112l-2 0-160 0-16 0 0 16-32 0zM80 272l0-80 0-16 128 0 0 96L80 272zM256 0C148.6 0 56.6 66.2 18.6 160L16 160 0 160l0 32 8.1 0C2.8 212.5 0 233.9 0 256C0 397.4 114.6 512 256 512s256-114.6 256-256c0-22.1-2.8-43.5-8.1-64l8.1 0 0-32-16 0-2.6 0C455.4 66.2 363.4 0 256 0zM432 192l0 80-128 0 0-96 128 0 0 16zM256 416c71.6 0 113.7-47.7 126.3-72.8l-28.6-14.3C344.9 346.3 312.4 384 256 384s-88.9-37.7-97.7-55.2l-28.6 14.3C142.3 368.3 184.4 416 256 416zM192.4 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceGlasses = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;